import { useParams, Link, Navigate } from "react-router-dom";
import LegalLayout from "@/components/LegalLayout";
import Seo from "@/components/Seo";
import { getSegment } from "@/data/segments";
import { CAL_LINK } from "@/lib/booking";
import { breadcrumbSchema, faqPageSchema, serviceSchema } from "@/lib/schema";

export const SegmentPage = () => {
  const { segment } = useParams();
  const data = getSegment(segment);

  if (!data) return <Navigate to="/" replace />;

  const path = `/fuer/${segment}`;
  const jsonLd = [
    serviceSchema({ name: data.h1, description: data.metaDescription, path }),
    breadcrumbSchema([
      { name: "Startseite", path: "/" },
      { name: data.navLabel, path },
    ]),
  ];
  if (data.faqDemo) jsonLd.push(faqPageSchema(data.faqDemo));

  return (
    <LegalLayout title={data.h1} updated={null}>
      <Seo title={`${data.h1} – Kurpfalz Automation`} description={data.metaDescription} path={path} jsonLd={jsonLd} />
      <p className="text-sm font-semibold uppercase tracking-wide text-[#9A8420]">
        {data.eyebrow}
      </p>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Die Ausgangslage</h2>
        <p className="mt-2">{data.painPoint}</p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">So hilft Kurpfalz Automation</h2>
        <p className="mt-2">{data.solutionIntro}</p>
        <ul className="mt-3 list-disc pl-5 space-y-1.5">
          {data.bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      </section>

      {data.faqDemo && (
        <section>
          <h2 className="font-semibold text-lg text-[#16273F]">So beantwortet und qualifiziert der Bot</h2>
          <div className="mt-4 space-y-4">
            {data.faqDemo.map((item) => (
              <div key={item.q} className="rounded-xl border border-slate-200 bg-[#FAF8F2] p-5">
                <p className="font-semibold text-[#16273F]">„{item.q}"</p>
                <p className="mt-2 text-slate-600">{item.a}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <div className="pt-2">
        <a
          href={CAL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-[#16273F] hover:bg-[#0E1B2E] text-white text-base font-semibold transition-colors"
        >
          {data.ctaText}
        </a>
      </div>

      <p className="text-sm text-slate-500">
        Noch keinen Termin?{" "}
        <a href="/#kontakt" className="underline hover:text-[#16273F]">
          Lieber erst kurz schreiben
        </a>
        . Mehr zu unseren Leistungen finden Sie auch auf der{" "}
        <Link to="/" className="underline hover:text-[#16273F]">
          Startseite
        </Link>
        .
      </p>
    </LegalLayout>
  );
};

export default SegmentPage;
